import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component, Fragment } from 'react'
import styled from 'styled-components'
import SectionHeader from '../../components/SectionHeader'
import CheckLoginStatus from '../../conditions/CheckLoginStatus'
import DashboardLayout from '../../layouts/DashboardLayout'
import request from '../../utils/request'
import UserInfo from './UserInfo'
import UserPassword from './UserPassword'
import UserPhone from './UserPhone'
import Card from "../../components/Card"

const Loading = styled.div`
  font-size: 3rem;
  color: var(--gray);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 15rem;
`

@observer
export default class Profile extends Component {
  @observable fields = null

  @action
  setFields = fields => {
    this.fields = fields
  }

  getFields = async () => {
    const req = await request('/api/user/getFields')

    if (req.success) {
      this.setFields(req.data.fields)
    }
  }

  componentDidMount() {
    this.getFields()
  }

  render() {
    return (
      <CheckLoginStatus loggedOutRedirect="/">
        <DashboardLayout title="Profile">
          {this.fields &&
            <Fragment>
              <SectionHeader icon="fas fa-user-circle" color="dark-blue" str="titles.userInformation" />
              <UserInfo fields={this.fields} />
              <SectionHeader icon="fas fa-envelope" color="dark-blue" str="titles.email" />
              <Card><Card.Pad>Email cannot be changed at this time. If you need assistance, please contact Connor or Paula Anne.</Card.Pad></Card>
              <SectionHeader icon="fas fa-mobile" color="dark-blue" str="Authentication" />
              <UserPhone fields={this.fields} />
              <UserPassword />
            </Fragment>
          }
          {!this.fields &&
            <Loading>
              <i className="fas fa-sync fa-spin" />
            </Loading>
          }
        </DashboardLayout>
      </CheckLoginStatus>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Profile/index.js